import styled from 'styled-components';

export const VastTrackerWrapper = styled.div`
  padding: 20px 50px;
  display: flex;
  flex-direction: column;
  height: 1300px;
`;
